export default "__VITE_ASSET__DkDpsbPo__"